// extracted by mini-css-extract-plugin
export default {"container":"navigate-overlay_container__Od-+e"};